// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const sled = defineModel({
  id: "sled",
  batchId: "future",
  name: "Sled",
  tags: ["scenery","sled","low-poly","age-of-mcp","future"],
  summary: "A cargo sled for dragging loads over rough ground or snow.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.35,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.06, 0.06, 0.6), color: "#6e4f2e", position: [-0.16, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.06, 0.18), color: "#6e4f2e", position: [-0.16, 0.08, 0.32], rotation: [-0.7, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.06, 0.6), color: "#6e4f2e", position: [0.16, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.06, 0.18), color: "#6e4f2e", position: [0.16, 0.08, 0.32], rotation: [-0.7, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.42, 0.04, 0.1), color: "#8a6840", position: [0, 0.1, -0.18] },
      { geometry: new THREE.BoxGeometry(0.42, 0.04, 0.1), color: "#8a6840", position: [0, 0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.42, 0.04, 0.1), color: "#8a6840", position: [0, 0.1, 0.18] },
      { geometry: new THREE.BoxGeometry(0.34, 0.24, 0.34), color: "#a9763f", position: [0, 0.24, -0.02] },
      { geometry: new THREE.BoxGeometry(0.36, 0.02, 0.03), color: "#b9a574", position: [0, 0.3, -0.1] },
      { geometry: new THREE.BoxGeometry(0.03, 0.02, 0.36), color: "#b9a574", position: [0, 0.3, -0.02] },
    ],
  animations: [],
});
